export default "__VITE_ASSET__BBXHltzX__"